<template>
  <div class="app">
    <component :is="((this.$route.meta.layout||this.$config.app.layout)||'layout')">
    </component>
  </div>
</template>
<script>
  import { Layouts } from './layouts';

  export default {
    components: {
      layout: Layouts['Layout'],
      layout1: Layouts['Layout1']
    }
  };
</script>
